"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentCapabilityGaps = exports.AGENT_CAPABILITY_GAPS = void 0;
exports.AGENT_CAPABILITY_GAPS = {
    job_search: {
        id: "job_search",
        stops: "Launches on this run environment are refused.",
        remedy: "Upgrade the agent to 0.2.0 or later.",
    },
    uploads_need_upgrade: {
        id: "uploads_need_upgrade",
        stops: "Uploads, and launches that read a writable data source, are refused on this run environment.",
        remedy: "Upgrade the agent to 0.3.0 or later.",
    },
    run_input_upload: {
        id: "run_input_upload",
        stops: "Uploading a run input is refused.",
        remedy: "Upgrade the agent to 0.3.0 or later.",
    },
    datasource_write: {
        id: "datasource_write",
        stops: "Uploads to data sources, and launches that read a writable data source, are refused on this run environment.",
        remedy: "Configure a write folder on the agent with foundry-agent configure --write-root, then restart it.",
    },
    workspace_jobs: {
        id: "workspace_jobs",
        stops: "Apps and the workbench are unavailable on this run environment.",
        remedy: "Upgrade the agent to 0.4.0 or later, declare a folder jobs may mount with foundry-agent mount-roots add, and restart it. The cluster must use LSF or Slurm.",
    },
    app_relay: {
        id: "app_relay",
        stops: "Apps on your cluster cannot be launched on this run environment.",
        remedy: "Upgrade the agent to 0.7.0 or later.",
    },
    app_sif_image: {
        id: "app_sif_image",
        stops: "Apps that start from a .sif image file cannot be launched on this run environment.",
        remedy: "Upgrade the agent to 0.8.0 or later.",
    },
};
const agentCapabilityGaps = (capabilities, options) => {
    if (null === capabilities || undefined === capabilities)
        return [];
    const has = (capability) => capabilities.includes(capability);
    const gaps = [];
    if (!has("job_search"))
        gaps.push(exports.AGENT_CAPABILITY_GAPS.job_search);
    if (!has("run_input_upload") && !has("datasource_write")) {
        gaps.push(exports.AGENT_CAPABILITY_GAPS.uploads_need_upgrade);
    }
    else if (!has("run_input_upload")) {
        gaps.push(exports.AGENT_CAPABILITY_GAPS.run_input_upload);
    }
    else if (!has("datasource_write")) {
        gaps.push(exports.AGENT_CAPABILITY_GAPS.datasource_write);
    }
    if (options.hpcAppsEnabled) {
        if (!has("workspace_jobs"))
            gaps.push(exports.AGENT_CAPABILITY_GAPS.workspace_jobs);
        if (!has("app_relay"))
            gaps.push(exports.AGENT_CAPABILITY_GAPS.app_relay);
        if (!has("app_sif_image"))
            gaps.push(exports.AGENT_CAPABILITY_GAPS.app_sif_image);
    }
    return gaps;
};
exports.agentCapabilityGaps = agentCapabilityGaps;
